import { ErrorHandler } from '@angular/core'
import { apm } from '@elastic/apm-rum'

export class APMErrorHandler implements ErrorHandler {
  handleError(error) {
    apm.captureError(error)
  }
}

